<p500-ui-many-items [data]="data" [title]="title" [tmpl]="tmpl" [buttonTmpl]="buttonTmpl" [previewTmpl]="previewTmpl"></p500-ui-many-items>
<ng-template let-data="data" #tmpl>
  <ng-container *ngIf="data && data?.id; else emptyTmpl">
    <span i18n="@@earning.invoice_for" class="mr-5">Invoice for</span>
    <gtd-ui-field-default-money [data]="data.total"></gtd-ui-field-default-money>&nbsp;
    <span i18n="@@earning.with_status">with status</span> "{{ statusTranslation[data.status] || data.status }}"&nbsp;
    <span i18n="@@common.from">from</span><gtd-ui-field-default-datetime [data]="data.from"></gtd-ui-field-default-datetime>&nbsp;
    <span i18n="@@common.to">to</span><gtd-ui-field-default-datetime [data]="data.to"></gtd-ui-field-default-datetime>
  </ng-container>
  <ng-template #emptyTmpl>&nbsp;</ng-template>
</ng-template>
<ng-template let-open="open" #buttonTmpl>
  <div class="c-field-value c-field-value--view-mode d-flex">
    <span class="c-field-value__icon" (click)="open($event)">
      <p500-ui-icon name="eye"></p500-ui-icon>
    </span>
    <span>{{ text }}</span>
  </div>
</ng-template>
<ng-template #previewTmpl></ng-template>
